import { buffers } from 'redux-saga';
import {
	take,
	call,
	put,
	all,
	actionChannel,
	select,
} from 'redux-saga/effects';
import { requestHandler } from './fetcher.saga';
import {
	SET_VARIABLE_SERVER,
	UPDATE_VARIABLE_SERVER,
} from '../constants/variableServer';
import { MERGE_RULES_CHILDREN_GET } from '../constants/patchMenu';
import {
	PRE_SET_SERVICE_LANG,
	UPDATE_SESSION_ID,
	PRE_SET_SELECTED_DATE,
} from '../constants/variableServer';
import { browserHistory } from 'react-router';

const PRE_REQUEST_SET_SERVICE_LANG = 'PRE_REQUEST_SET_SERVICE_LANG';
const REQUEST_SET_SERVICE_LANG_FINISHED = 'REQUEST_SET_SERVICE_LANG_FINISHED';
const PRE_REQUEST_UPDATE_SESSION_ID = 'PRE_REQUEST_UPDATE_SESSION_ID';
const REQUEST_UPDATE_SESSION_ID_FINISHED = 'REQUEST_UPDATE_SESSION_ID_FINISHED';
const PRE_REQUEST_SET_SELECTED_DATE = 'PRE_REQUEST_SET_SELECTED_DATE';
const REQUEST_SET_SELECTED_DATE_FINISHED = 'REQUEST_SET_SELECTED_DATE_FINISHED';

function* preSetServiceLang() {
	while (true) {
		const { lang } = yield take(PRE_SET_SERVICE_LANG);

		yield put({ type: PRE_REQUEST_SET_SERVICE_LANG, lang });
		yield take(REQUEST_SET_SERVICE_LANG_FINISHED);

		window.location.reload();
	}
}

function* watchSetServiceLang() {
	const requestChan = yield actionChannel(
		PRE_REQUEST_SET_SERVICE_LANG,
		buffers.expanding()
	);
	while (true) {
		const { lang } = yield take(requestChan);
		yield call(
			requestHandler,
			'variableServer',
			'POST',
			true,
			{ lang },
			'/set-lang'
		);
		yield put({ type: REQUEST_SET_SERVICE_LANG_FINISHED });
	}
}

function* preUpdateSession() {
	while (true) {
		const { master_mono_use, reload } = yield take(UPDATE_SESSION_ID);

		yield put({
			type: PRE_REQUEST_UPDATE_SESSION_ID,
			body: { uuid: window.sessionStorage.getItem('guid'), master_mono_use },
		});
		yield take(REQUEST_UPDATE_SESSION_ID_FINISHED);
		if (reload) {
			window.sessionStorage.setItem('ALREADY_IN_USE', false);
			window.location.reload();
		}
	}
}

function* watchSetUpdateSession() {
	const requestChan = yield actionChannel(
		PRE_REQUEST_UPDATE_SESSION_ID,
		buffers.expanding()
	);
	while (true) {
		const { body } = yield take(requestChan);
		yield call(
			requestHandler,
			'variableServer',
			'PUT',
			true,
			body,
			'/update-session'
		);
		yield put({ type: REQUEST_UPDATE_SESSION_ID_FINISHED });
	}
}

function* preSetSelectedDate() {
	while (true) {
		const { date } = yield take(PRE_SET_SELECTED_DATE);

		yield put({ type: PRE_REQUEST_SET_SELECTED_DATE, date });
		yield take(REQUEST_SET_SELECTED_DATE_FINISHED);

		//if master mono alors on le fait aussi sur le master
		if (window.sessionStorage.getItem('master_mono_child')) {
			yield put({ type: PRE_REQUEST_SET_SELECTED_DATE, date, bypass: true });
			yield take(REQUEST_SET_SELECTED_DATE_FINISHED);
		}

		browserHistory.push('/');
		window.location.reload();
	}
}

function* watchSetSelectedDate() {
	while (true) {
		const { date, bypass } = yield take(PRE_REQUEST_SET_SELECTED_DATE);
		yield call(
			requestHandler,
			'variableServer',
			'POST',
			true,
			{ date },
			'/select-date',
			{},
			bypass
		);
		yield put({ type: REQUEST_SET_SELECTED_DATE_FINISHED });
	}
}

function* setMenuAllowHidden() {
	while (true) {
		const { value } = yield take('REQUEST_SET_MENU_ALLOW_HIDDEN');
		yield put({ type: 'UPDATE_VARIABLE', key: 'menu_allow_hidden_p', value }); // maj a but visuelle (fonctionelement inutile puisque on refresh mais bon ux ux)
		yield put({
			type: 'REQUEST_SET_VARIABLE',
			key: 'menu_allow_hidden_p',
			value,
		});
		yield take('REQUEST_SET_VARIABLE_FINISHED');
		window.location.reload();
	}
}

// Écriture d'une clé de variable_server. Le store est mis à jour après la
// réponse et non avant : cette valeur commande des droits, mieux vaut que
// l'interface reflète ce qui est réellement enregistré.
function* setVariableServerKey() {
	while (true) {
		const { key, value, id_company } = yield take(SET_VARIABLE_SERVER);
		const { result } = yield call(
			requestHandler,
			'variableServer',
			'POST',
			true,
			id_company ? { key, value, id_company } : { key, value },
			'/set-variable'
		);
		if (result && result.result) {
			if (id_company) {
				// La valeur écrite est celle d'un établissement, pas du compte
				// courant : on relit le parc plutôt que de toucher au store
				// local, qui décrit le siège.
				yield put({ type: MERGE_RULES_CHILDREN_GET });
			} else {
				yield put({ type: UPDATE_VARIABLE_SERVER, key, value });
			}
		}
	}
}

function* postVariable() {
	while (true) {
		const { key, value } = yield take('REQUEST_SET_VARIABLE');
		yield call(requestHandler, 'variable', 'POST', true, { key, value });
		yield put({ type: 'REQUEST_SET_VARIABLE_FINISHED' });
	}
}

export default function* variableServerSaga() {
	yield all([
		preSetServiceLang(),
		watchSetServiceLang(),
		setVariableServerKey(),
		preUpdateSession(),
		watchSetUpdateSession(),
		preSetSelectedDate(),
		watchSetSelectedDate(),
		setMenuAllowHidden(),
		postVariable(),
	]);
}
